!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t();else if ("function" == typeof define && define.amd) define([], t);else {
    var r = t();

    for (var o in r) {
      ("object" == typeof exports ? exports : e)[o] = r[o];
    }
  }
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    var t = {};

    function r(o) {
      if (t[o]) return t[o].exports;
      var n = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, o) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        r.d(o, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return o;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
  }([function (e, t, r) {
    "use strict";

    function o(e) {
      return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.uiColors = void 0;

    var n = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== o(e) && "function" != typeof e) return {
        default: e
      };
      var t = u();
      if (t && t.has(e)) return t.get(e);
      var r = {},
          n = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var i in e) {
        if (Object.prototype.hasOwnProperty.call(e, i)) {
          var l = n ? Object.getOwnPropertyDescriptor(e, i) : null;
          l && (l.get || l.set) ? Object.defineProperty(r, i, l) : r[i] = e[i];
        }
      }

      r.default = e, t && t.set(e, r);
      return r;
    }(r(1));

    function u() {
      if ("function" != typeof WeakMap) return null;
      var e = new WeakMap();
      return u = function u() {
        return e;
      }, e;
    }

    t.uiColors = n, r(2);
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.red = t.yellow = t.blue = t.green = t.gray = t.black = t.white = void 0;
    t.white = "#FFFFFF";
    t.black = "#061621";
    t.gray = {
      dark3: "#21313C",
      dark2: "#3D4F58",
      dark1: "#5D6C74",
      base: "#89989B",
      light1: "#B8C4C2",
      light2: "#E7EEEC",
      light3: "#F9FBFA"
    };
    t.green = {
      dark3: "#0B3B35",
      dark2: "#116149",
      base: "#13AA52",
      light2: "#C3E7CA",
      light3: "#E4F4E4"
    };
    t.blue = {
      dark3: "#0D324F",
      dark2: "#1A567E",
      base: "#007CAD",
      light2: "#C5E4F2",
      light3: "#E1F2F6"
    };
    t.yellow = {
      dark3: "#543E07",
      dark2: "#86681D",
      base: "#FFDD49",
      light2: "#FEF2C8",
      light3: "#FEF7E3"
    };
    t.red = {
      dark3: "#570B08",
      dark2: "#8F221B",
      base: "#CF4A22",
      light2: "#F9D3C5",
      light3: "#FCEBE2"
    };
  }, function (e, t, r) {
    "use strict";

    r.r(t), t.default = r.p + "ui-colors.less";
  }]);
});